import React from "react";
import CRUDAdmin from "../../components/admin/CRUDAdmin";

export default function Packages() {
  return (
    <CRUDAdmin
      title="Packages"
      subtitle="Curated catering packages displayed on the public website."
      endpoint="/admin/packages"
      testIdPrefix="pkg"
      defaults={{ active: true, order: 100, currency: "INR", price_unit: "per plate", inclusions: [] }}
      columns={[
        { title: "Name", render: r => <><div className="serif text-lg">{r.name}</div><div className="text-navy-900/50 text-xs">{r.tagline}</div></> },
        { title: "Price", render: r => <span className="text-gold serif text-xl">₹{r.price}</span> },
        { title: "Signature", render: r => r.is_signature ? "Yes" : "—" },
        { title: "Order", render: r => r.order },
      ]}
      fields={[
        { name: "name", label: "Name" },
        { name: "slug", label: "Slug" },
        { name: "tagline", label: "Tagline" },
        { name: "price", label: "Price (₹)", type: "number" },
        { name: "price_unit", label: "Price Unit" },
        { name: "order", label: "Display Order", type: "number" },
        { name: "ideal_for", label: "Ideal For" },
        { name: "min_guests", label: "Minimum Guests", type: "number" },
        { name: "description", label: "Description", type: "textarea", full: true },
        { name: "inclusions", label: "Inclusions", type: "list", full: true, placeholder: "Add inclusion (e.g. 5 Starters · Veg)" },
        { name: "image_url", label: "Image", type: "media", full: true },
        { name: "is_signature", label: "Signature Package", type: "checkbox", checkboxLabel: "Mark as Royal Signature" },
        { name: "active", label: "Visible on website", type: "checkbox", checkboxLabel: "Active" },
      ]}
    />
  );
}
